import { render, staticRenderFns } from "./PaymentsMethods.vue?vue&type=template&id=da4fd6ca&scoped=true&"
import script from "./PaymentsMethods.vue?vue&type=script&lang=ts&"
export * from "./PaymentsMethods.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4fd6ca",
  null
  
)

export default component.exports